import { z } from 'zod/v3';

import type { ListRunsParams } from '@/api/generated/model';

export const runStatuses = [
	'received',
	'blocked',
	'pending_approval',
	'rejected',
	'executing',
	'completed',
	'failed',
] as const;
export type RunStatusValue = (typeof runStatuses)[number];

export const triggerSources = ['manual', 'fortytools', 'pland'] as const;
export type TriggerSourceValue = (typeof triggerSources)[number];

export const sourceFilterValues = ['all', ...triggerSources] as const;

export const runsSearchSchema = z.object({
	page: z.coerce.number().int().positive().default(1),
	perPage: z.coerce.number().int().positive().max(100).default(10),
	status: z.array(z.enum(runStatuses)).default([]),
	source: z.enum(sourceFilterValues).default('all'),
	q: z.string().default(''),
});

export type RunsSearch = z.infer<typeof runsSearchSchema>;

export function toListRunsParams(search: RunsSearch): ListRunsParams {
	const q = search.q.trim();
	return {
		page: search.page,
		per_page: search.perPage,
		status: search.status.length > 0 ? [...search.status] : undefined,
		triggerSource: search.source === 'all' ? undefined : search.source,
		q: q === '' ? undefined : q,
	};
}
